export default "<span class=\"ccc-alert\"></span>";